import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Stack,
  Box,
} from '@mui/material';
import { ErrorTableCell, ErrorTableHeadCell } from './ProjectErrorTable.styles';
import { ErrorStateItem } from 'organisms/CloudOpsReportAdmin/types';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/checkmark.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { IZohoProject } from 'pages/CompanyPage/types';

const ProjectErrorTable: FC<{ project: IZohoProject }> = ({ project }) => {
  const errors = project?.error_labels_links;

  if (!errors?.length) return <span />;

  return (
    <TableContainer sx={{ maxHeight: 300 }}>
      <Table stickyHeader aria-label="Time logs table">
        <TableHead>
          <TableRow>
            <ErrorTableHeadCell>Field name</ErrorTableHeadCell>
            <ErrorTableHeadCell>Check results</ErrorTableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {errors?.map(({ labels, links, error_states }) => (
            <TableRow key={labels || ''}>
              <ErrorTableCell>
                <Stack>
                  {labels}
                  <Link to={links} target="_blank" rel="noopener noreferrer">
                    View in Zoho Projects
                  </Link>
                </Stack>
              </ErrorTableCell>
              <ErrorTableCell>
                {error_states?.length ? (
                  <Stack>
                    {error_states.map((item: ErrorStateItem) =>
                      ['0', '0.0', '0.00'].includes(item.message) ? (
                        <Box
                          key={item.property}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            backgroundColor: 'error.main',
                            lineHeight: 0,
                            '& svg': {
                              width: 8,
                              height: 8,
                            },
                            '& path': {
                              fill: '#FFF',
                            },
                          }}
                        >
                          <CloseIcon />
                        </Box>
                      ) : (
                        <span key={item.property}>{item.message}</span>
                      )
                    )}
                  </Stack>
                ) : (
                  <CheckmarkIcon />
                )}
              </ErrorTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProjectErrorTable;
